/**
 * Whether the browser can show an attachment in a tab (OLIO-3600).
 *
 * The api serves attachments with ActiveStorage's defaults: only `content_types_allowed_inline`
 * (PDF and common images) are sent inline. Everything else, HTML included, is sent as a
 * download, so a tab opened for it is left blank. Keep this list in step with the api's.
 *
 * An unknown type counts as viewable, so anything that opens today still does.
 */
const VIEWABLE_CONTENT_TYPES = new Set([
  'application/pdf',
  'image/avif',
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/tiff',
  'image/vnd.adobe.photoshop',
  'image/vnd.microsoft.icon',
  'image/webp',
]);

export function isViewableInBrowser(contentType: string | null | undefined): boolean {
  const type = (contentType ?? '').split(';')[0].trim().toLowerCase();
  return !type || VIEWABLE_CONTENT_TYPES.has(type);
}

// A link navigation to a download leaves the page where it is.
export function downloadInPlace(url: string) {
  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
}
